import { projectRequest } from 'store/utils/request';

export default ({
  selectedEntity,
  newEntity,
}: {
  selectedEntity: string;
  newEntity: string;
}) =>
  projectRequest.post(`/entities/${selectedEntity}/replace_usages/`, {
    new_entity: newEntity,
  });
